import { StyledLabel } from '@/common/components/base-app/atoms/Input/Input.styles';
import { styled } from '@/stitches.config';

const RootContainer = styled('section', {
  border: '1px solid $seafoam400',
  padding: '$4',
});

const TitleContainer = styled('div', {
  display: 'flex',
});

interface CampaignCardProps {
  title: string;
  secondaryLabel?: string;
  children?: React.ReactNode;
}

export const CampaignCard = ({ title, secondaryLabel, children }: CampaignCardProps): JSX.Element => {
  return (
    <RootContainer>
      <TitleContainer>
        <StyledLabel>{title}</StyledLabel>
        <StyledLabel css={{ fontWeight: 300, fontSize: '14px', marginLeft: '$1' }}>
          <em>{secondaryLabel}</em>
        </StyledLabel>
      </TitleContainer>
      {children}
    </RootContainer>
  );
};
